import { categories, formatReads, siteName, siteSlogan } from '@/mocks/gossip';

const stats = [
  { num: '6', unit: '个', label: '常设栏目' },
  { num: '28', unit: '期+', label: '持续盘点' },
  { num: '10', unit: 'w+', label: '累计围观' },
  { num: '24', unit: 'h', label: '活动速递' },
];

export default function Hero() {
  return (
    <section
      id="top"
      className="relative flex min-h-[92vh] w-full flex-col justify-center overflow-hidden bg-foreground-900"
    >
      {/* 背景大图 */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=editorial%20red%20carpet%20fashion%20still%20life%20stylized%20gowns%20with%20glitter%20sequins%20and%20feathers%20floating%20in%20dark%20space%20dramatic%20cinematic%20warm%20crimson%20gold%20and%20ivory%20palette%20magazine%20cover%20art%20bold%20contrast%20luxurious%20texture&width=1600&height=1000&seq=hero-gua-01&orientation=landscape')",
        }}
      ></div>
      {/* 压暗遮罩，保证文字可读 */}
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-900/55 to-background-50/95"></div>

      <div className="relative mx-auto w-full max-w-[1240px] px-4 pb-24 pt-36 md:px-6 md:pt-40">
        <div className="flex w-full flex-col items-center text-center">
          {/* 眉题 */}
          <p className="inline-flex items-center gap-2 rounded-full border border-accent-300/40 bg-accent-300/10 px-4 py-1.5 text-xs font-medium tracking-[0.2em] text-accent-200">
            <i className="ri-sparkling-line text-sm"></i>
            吃瓜周刊 · 红毯造型风向标
            <i className="ri-sparkling-line text-sm"></i>
          </p>

          {/* 主标题 H1 */}
          <h1 className="mt-7 font-display text-5xl font-black leading-tight text-background-50 md:text-7xl">
            八卦吃瓜
            <span className="mx-3 inline-block h-[0.7em] w-[3px] translate-y-1 bg-accent-400"></span>
            把红毯翻车
            <span className="relative inline-block text-accent-300">一次看个够</span>
          </h1>

          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
            从拖尾绊脚到裙摆“掀桌”，从造型雷人到同款撞衫，再到妆面翻车与时尚灾难——{siteSlogan}。
            小编负责切瓜、拆解、点评，你只管抱着薯片一次看到饱。
          </p>

          {/* 动作按钮 */}
          <div className="mt-9 flex w-full flex-col items-center justify-center gap-3 sm:w-auto sm:flex-row">
            <a
              href="#pan"
              className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              开始吃瓜
              <i className="ri-arrow-down-line ml-2 text-base"></i>
            </a>
            <a
              href="#hot"
              className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/5 px-7 py-3.5 text-sm font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50 hover:text-foreground-900 sm:w-auto"
            >
              <i className="ri-fire-line mr-2 text-lg text-accent-300"></i>
              今日热瓜榜
            </a>
          </div>

          {/* 栏目快入口 */}
          <div className="mt-10 flex max-w-3xl flex-wrap items-center justify-center gap-2.5">
            {categories.map((c) => (
              <a
                key={c.id}
                href="#pan"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-50/20 bg-background-50/5 px-4 py-1.5 text-xs font-medium text-background-100/90 transition-colors hover:border-accent-300/50 hover:text-accent-200"
              >
                <i className={`${c.icon} text-sm text-accent-300`}></i>
                {c.name}
              </a>
            ))}
          </div>

          {/* 数据条 */}
          <dl className="mt-12 grid w-full grid-cols-2 gap-3 border-t border-background-50/15 pt-7 sm:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label} className="flex flex-col items-center">
                <dt className="order-2 mt-1 text-xs text-background-100/70">{s.label}</dt>
                <dd className="order-1 font-display text-2xl font-black text-background-50 md:text-3xl">
                  {s.num}
                  <span className="ml-0.5 text-sm font-bold text-accent-300">{s.unit}</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}